import ProjectedIncomeDetails from './ProjectedIncomeDetails'

export default ProjectedIncomeDetails
